Attributes of the newly created position profile for the job ad.
